<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-content">
      <el-table ref="student_record" :data="studentLists" border>
        <el-table-column prop="goods_name" label="中奖商品" />
        <el-table-column prop="sub_name" label="中奖用户" />
        <el-table-column prop="mobile" label="手机号" />
        <el-table-column prop="shop_name" label="校区" />
        <!-- <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="popImprove(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="fnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>

    </div>

    <!-- <el-dialog v-if="dialogExchange" title="转换课时包" :visible.sync="dialogExchange" width="600px">
      <active-exchange-course :key="improveKey" :relation-id="relationId" @successCBK="fnGetLists()" />
    </el-dialog> -->
  </div>
</template>
<script>

import Tool from '@/assets/js/tool.js'

export default {
  name: 'ActiveLuckyCorrectLists',
  components: {

  },
  data() {
    return {
      dialogImprove: false,
      dialogExchange: false,
      improveKey: 999,
      relationId: '',
      listQuery: {
        total: 0,
        p: 1,
        limit: 20,
        activity_id: ''
      },
      studentLists: []
    }
  },
  created() {
    this.listQuery.lottery_id = this.$route.query.id
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.dialogImprove = false
      this.dialogExchange = false
      this.$http.getLuckyRecordList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count || 0)
        this.studentLists = res.data.list
      })
    },
    fnExportExcel() {
      Tool.exportExcelElTable('活动学生', this.$refs['student_record'])
    },

    fnDelete(id) {
      this.$confirm('是否删除该报名学员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.removeJoinSub({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnToDetail() {

    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
